import { useSamplesDustDensityBaseDataCreateMutation } from "@/services/backend/samples/api/dust-density-base-data-api";
import { CreateSampleBaseDataDialog } from "@/services/backend/samples/components/create-sample-base-data-dialog";

export function CreateDustDensityBaseDataDialog() {
  const mutation = useSamplesDustDensityBaseDataCreateMutation();
  return <CreateSampleBaseDataDialog mutation={mutation} />;
}
